import React, { useContext, useState, useRef } from 'react';

import Modal from '~/commons/components/Modal.jsx';

const Context = React.createContext({
  alert: () => {},
});

const useModalAlert = () => useContext(Context);

const ModalAlert = ({ children }) => {
  const [show, setShow] = useState(false);
  const [theme, setTheme] = useState('primary');
  const content = useRef('');

  const alert = (c, t = 'primary') => {
    content.current = c;
    setTheme(t);
    setShow(true);
  };

  return (
    <Context.Provider value={{ alert }}>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
      >
        <div className="text-center px-4 pt-3">
          {content.current}
          <div className="mt-4">
            <button
              onClick={() => setShow(false)}
              className={`m-2 btn btn-${theme} btn-fixed-w`}
            >
              確定
            </button>
          </div>
        </div>
      </Modal>
      {children}
    </Context.Provider>
  );
};

export { useModalAlert };

export default ModalAlert;
